import { h } from 'preact'
import Router from 'preact-router'
import AsyncRoute from 'preact-async-route'
// import Loading from '../components/Loading/Loading'

import { ROUTES } from './ROUTES'

// TODO: generate routes from route array?
const HOME = () => import('../screens/Home').then((module) => module.default)

const Routes = () => {
    const handleRoute = () => {
        if (typeof window.scrollTo === 'function') {
            window.scrollTo({ top: 0, left: 0 })
        }
    }

    return (
        <main>
            <Router onChange={handleRoute}>
                <AsyncRoute path={ROUTES.HOME} getComponent={HOME} />
            </Router>
        </main>
    )
}

export default Routes
